import { render, staticRenderFns } from "./pcConfig.vue?vue&type=template&id=77f9e839&scoped=true&"
import script from "./pcConfig.vue?vue&type=script&lang=js&"
export * from "./pcConfig.vue?vue&type=script&lang=js&"
import style0 from "./pcConfig.vue?vue&type=style&index=0&id=77f9e839&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f9e839",
  null
  
)

export default component.exports